import { useAuth } from '../../hooks';
import { isReadOnlyRole } from '../../@types/auth';
import { Navigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import React from 'react';

const RoleBasedRedirect = ({ children }: { children: React.ReactNode }) => {
    const { user } = useAuth();
    const location = useLocation();
    const locationSchedule = '/schedule';

    if (!user) {
        return null;
    }

    if (!(location.pathname === locationSchedule) && isReadOnlyRole(user.roles)) {
        return <Navigate to={locationSchedule} replace/>
    }

    return <React.Fragment>{children}</React.Fragment>;
}

export default RoleBasedRedirect;